const carousel = () => {
    return {
        swiper: null,

        init() {
            this.swiper = new Swiper(this.$refs.container, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,

                pagination: {
                    el: this.$refs.navigation,
                    clickable: true,
                },
            });
        }
    }
}